/* global angular */

var ngModule = angular.module('trends');

/* a service that saves information from the page into various stores*/
ngModule.service('HistoricContext', ['Api', '$window', function(Api, $window) {
    var memory = {
        'session': {}, // save per session (not shared between browser tabs)
        'local': {}, // save in local browser storage
        'db': {}, // save as a jeckyll product option
    };

    /* XXX: In order to make this a bit more generic, this service could be
        refactored to a factory, then OPTION_NAME would not need to be
        hard-coded. */

    var OPTION_NAME = 'Trends_Page_History';
    var INSERT_TYPE_DEFAULT = 'local';

   /* data should be loaded from the various sources before any clients attempt
       to access the contained data */
    var loaded = false;

    /* don't save values to unrequired stores, really for the sake of the
        database store */
    var changed = {
        'session': false,
        'local': false,
        'db': false,
    };

    angular.extend(this, {
        insert: function(key, value, type) {
            if (!type) {
                type = INSERT_TYPE_DEFAULT;
            }

            memory[type][key] = value;
            changed[type] = true;
        },
        build: function() {
            Api.productOption.get({'name': OPTION_NAME }).then(function(response) {
                var value = response.value;
                if (value) {
                    memory.db = angular.fromJson(value);
                }
            });

            memory.local = angular.fromJson($window.localStorage.getItem(OPTION_NAME) || '{}');
            memory.session = angular.fromJson($window.sessionStorage.getItem(OPTION_NAME) || '{}');

            loaded = true;
        },
        get: function() {
            if (!loaded) {
                return {};
            }
            return memory;
        },
        getValue: function(name) {
            if (!loaded) {
                return null;
            }

            // retrieving a value is prioritized on the locality of the store
            // specifically session > local > db,
            for (var section in memory){
                if (name in memory[section]) {
                    return memory[section][name];
                }
            }

            return null;
        },
        save: function() {
            if (changed.db) {
                Api.productOption.customPUT({
                    'name': OPTION_NAME,
                    'value': angular.toJson(memory.db)
                });
            }

            if (changed.local) {
                try{
                    $window.localStorage.setItem(OPTION_NAME, angular.toJson(memory.local));
                }catch(e){
                    // Safari in private mode browsing does not have access to localStorage,
                    //so suppress the error and dont break the page
                }
            }
            if (changed.session) {
                $window.sessionStorage.setItem(OPTION_NAME, angular.toJson(memory.session));
            }

            for (var section in changed){
                changed[section] = false;
            }
        }
    });
}]).run(['HistoricContext', function(HistoricContext) {
    /* ensure that the memory is populated before the directives
    attempt access to minimize requests  */
    HistoricContext.build();
}]);

/* Directive which preserves a variable in scope via the historic context
    service */
ngModule.directive('preserveContext', ['HistoricContext',
    function (HistoricContext) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var name = attrs.name;
                var field = attrs.preserveContext;
                var storageType = attrs.storageType;

                var loadData = function() {
                    var data = HistoricContext.getValue(name);
                    // This prevents an existing value being overriten
                    // by a non existent value.
                    if(data) {
                        scope[field] = data;
                    }
                };

                scope.$watch(field, function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        HistoricContext.insert(name, newValue, storageType);
                        HistoricContext.save();
                    }
                }, true);

                loadData();
            }
        };
    }
]);
